<div class="d-flex align-items-center justify-content-end mb-0">
    <button mat-icon-button (click)="dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <form [formGroup]="form">
    <div class="row py-2">
      <div class="col-md-12">
        <div class="card-sub-heading">
          Promo Code
        </div>
        <div class="mb-2 mt-2">
          <mat-form-field>
            <mat-select formControlName="status" class="form-control matselect w-100"
            placeholder="Select Promo Code" formControlName="promo_code_id">
             <mat-option *ngFor="let item of promoCodeList" [value]="item.id">
               {{ item.code }}
             </mat-option>
           </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-end justify-content-end">
        <button class="custom-btn" (click)="dialogRef.close()" type="button">
          Cancel
        </button>
        <button class="custom-btn" type="submit" [disabled]="form.invalid" 
        (click)="formSubmit()">
          Confirm
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
  